import { Table, Button, Row, Col } from 'react-bootstrap';
import { FaEdit } from 'react-icons/fa';
import { useParams, useNavigate } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/Paginate';
import {
  useGetProductsQuery,
  //useCreateProductMutation,
  //useDeleteProductMutation,
} from '../../slices/productsApiSlice';
//import { toast } from 'react-toastify';
import moment from 'moment';

const ProductListScreenVendeur = () => {
  const { pageNumber } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, error } = useGetProductsQuery({
    pageNumber,
    sortBy: 'position_asc',
  });

  // const [createProduct, { isLoading: loadingCreate }] =
  //   useCreateProductMutation();
  // const [deleteProduct, { isLoading: loadingDelete }] =
  //   useDeleteProductMutation();

  // const createProductHandler = async () => {
  //   if (window.confirm('Are you sure you want to create a product?')) {
  //     try {
  //       await createProduct();
  //       toast.success('Product created');
  //       refetch();
  //     } catch (err) {
  //       toast.error(err?.data?.message || err.error);
  //     }
  //   }
  // };

  // const deleteHandler = async (id) => {
  //   if (window.confirm('Are you sure?')) {
  //     try {
  //       await deleteProduct(id);
  //       toast.success('Product deleted');
  //       refetch();
  //     } catch (err) {
  //       toast.error(err?.data?.message || err.error);
  //     }
  //   }
  // };

  const editProductHandler = (id) => {
    // Check if the user is in the office context, then navigate to the appropriate route
    //const isAdminContext = window.location.pathname.startsWith('/admin');
    const editPath = `/vendeur/product/${id}/edit`;
    navigate(editPath); 
  };

  return (
    <>
      <Row className='align-items-center'>
        <Col>
          <h1>Products</h1>
        </Col>
        {/* <Col className='text-end'>
          <Button className='btn-sm m-3' onClick={createProductHandler}>
            <FaEdit /> Create a product
          </Button>
        </Col> */}
      </Row>

      {/* {loadingCreate && <Loader />}
      {loadingDelete && <Loader />} */}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>Position</th>
                <th>Name</th>
                <th>Type</th>
                <th>Proprietaire</th>
                <th>TND</th>
                <th>EUR</th>
                <th>USD</th>
                <th>Date</th>
                <th>Category</th>
                <th>Brand</th>
                <th>Stock</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            {data.products
            .filter(product => product.type === 2) // Filtrer les produits avec type égal à 1
            .map(product => (
                <tr key={product._id}>
                  <td>{product.position}</td>
                  <td>{product.name}</td>
                  <td>{product.type}</td>
                  <td>{product.proprio}</td>
                  <td>{product.price}</td>
                  <td>{product.priceEur}</td>
                  <td>{product.priceDol}</td>
                  <td>{moment(product.date).format('DD MMMM YYYY')}</td>
                  <td>{product.category}</td>
                  <td>{product.brand}</td>
                  <td>{product.countInStock}</td>
                  <td>
                    <Button
                      variant='light'
                      className='btn-sm mx-2'
                      onClick={() => editProductHandler(product._id)}
                    >
                      <FaEdit />
                    </Button>
                    {/* <Button
                      variant='danger'
                      className='btn-sm'
                      onClick={() => deleteHandler(product._id)}
                    >
                      <FaTrash style={{ color: 'white' }} />
                    </Button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Paginate
            pages={data.pages}
            page={data.page}
            // keyword={keyword ? keyword : ''}
          />
        </>
      )}
    </>
  );
};

export default ProductListScreenVendeur;
